import { useState } from "react";
import { css } from "@emotion/react";

import { ReactComponent as CheckIcon } from "../../assets/check.svg";
import { shortenAddress } from "../../utils/shortenAddress";
import copy_icon from "../../assets/icons/copy_small.svg";
import { Container, Dots, Icon } from "./style";
import { BodyRegular } from "../../shared/typography";
import { useNavigate } from "react-router-dom";
import { verifyPath } from "../../module/routes/path";
import { Row } from "../../pages/Assets/style";


interface IConfig {
    title: string
    value: string
    display?: string
}
interface IProps {
    config: IConfig
    link?: string
    isHideCopy?: boolean
    isHideDots?: boolean
}
export const CustomTextbar = ({ config, link, isHideCopy, isHideDots }: IProps) => {
    const [isCopying, setIsCopying] = useState(false)
    const navigate = useNavigate()

    return (
        <Container isLink={Boolean(link)}>
            <Row className="wrapper" onClick={() => link ? navigate(link) : {}}>
                <BodyRegular color='#757272'>
                    {config?.title}
                </BodyRegular>
                {!isHideDots ? <Dots /> : <></>}

                <BodyRegular color='#191414'>
                    {config?.display ? config?.display : config?.value}
                </BodyRegular>
            </Row>
            {isHideCopy
                ? <></>
                : isCopying ?
                    <CheckIcon className="checkIcon" width={16} height={24} />
                    : navigator.clipboard ? <Icon
                        onClick={() => {
                            navigator.clipboard.writeText(link ? (window?.location?.origin ? (window?.location?.origin + link) : config?.value) : (config?.value));
                            setIsCopying(true);
                            setTimeout(() => {
                                setIsCopying(false);
                            }, 600);
                        }}
                        src={copy_icon}
                        alt=""
                    /> : <></>
            }
        </Container>
    )
}